
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resume",
      function () {
        return require("private-next-pages/resume/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resume"])
      });
    }
  